import { Component , OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SessionService} from './services/session.service';
import {gutil} from './gutil';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'new-yorfrontend';
  public user : any;

  constructor(private sessionService: SessionService){

  }
  
  
  ngOnInit(){
    this.user = JSON.parse(localStorage.getItem('currUser'));
    this.sessionService.getUser().subscribe(usr => { gutil.user = usr; this.user = usr;  });
    if(this.user != null && typeof this.user != 'undefined'){
      this.sessionService.setUser(this.user);
    }
  }
  
}
